import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=f13b005c&scoped=true&lang=pug&"
import script from "./AppMenu.vue?vue&type=script&lang=ts&"
export * from "./AppMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=f13b005c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13b005c",
  null
  
)

export default component.exports